import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const FlowList: AppRouteRecordRaw = {
  path: '/flow',
  name: 'flow',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '审批',
    requiresAuth: true,
    order: 6,
  },
  children: [
    {
      path: 'flowList',
      name: 'FlowList',
      component: () => import('@/views/flow/index.vue'),
      meta: {
        title: '审批列表',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['auditList'],
        activeMenu: 'FlowList',
      },
    },
  ],
};

export default FlowList;
